import { useMessageToast } from '../../shared/hooks/useMessageToast';
import { useBootstrapForm } from '../hooks/useBootstrapForm';
import { BUSINESS_TYPE_SLUGS } from '../../systemSettings/constants/organizationSettingsKeys';
import primitives from '../../../styles/primitives.module.css';
import styles from './BootstrapForm.module.css';

export const BootstrapForm = ({ onComplete, onExit, t }) => {
  const {
    formState,
    errorMessage,
    noticeMessage,
    isSubmitting,
    isComplete,
    handleInputChange,
    handleSubmit,
  } = useBootstrapForm({ t });

  useMessageToast(errorMessage, 'error');
  useMessageToast(noticeMessage, 'success');

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h2>{t('bootstrapTitle')}</h2>
        <p>{t('bootstrapSubtitle')}</p>
      </div>

      {!isComplete ? (
        <form className={`${primitives.form} ${styles.formGrid}`} onSubmit={handleSubmit}>
          <h3 className={styles.sectionLabel}>{t('bootstrapSectionAdmin')}</h3>
          <label className={primitives.field}>
            {t('usernameLabel')}
            <input
              type="text"
              name="username"
              autoComplete="username"
              value={formState.username}
              onChange={handleInputChange}
              placeholder={t('usernamePlaceholder')}
              required
            />
          </label>
          <label className={primitives.field}>
            {t('passwordLabel')}
            <input
              type="password"
              name="password"
              autoComplete="new-password"
              value={formState.password}
              onChange={handleInputChange}
              placeholder={t('passwordPlaceholder')}
              required
            />
          </label>

          <h3 className={styles.sectionLabel}>{t('bootstrapSectionOrganization')}</h3>
          <label className={primitives.field}>
            {t('bootstrapOrgName')}
            <input
              type="text"
              name="organization_name"
              autoComplete="organization"
              value={formState.organization_name}
              onChange={handleInputChange}
              placeholder={t('bootstrapOrgNamePlaceholder')}
              required
              maxLength={100}
            />
          </label>
          <label className={primitives.field}>
            {t('bootstrapBusinessType')}
            <select
              name="business_type"
              value={formState.business_type}
              onChange={handleInputChange}
              required
            >
              {BUSINESS_TYPE_SLUGS.map((slug) => (
                <option key={slug} value={slug}>
                  {t(`organizationBusinessType_${slug}`)}
                </option>
              ))}
            </select>
          </label>
          <label className={primitives.field}>
            {t('bootstrapOwnerName')}
            <input
              type="text"
              name="owner_name"
              autoComplete="name"
              value={formState.owner_name}
              onChange={handleInputChange}
              placeholder={t('bootstrapOwnerNamePlaceholder')}
              required
              maxLength={120}
            />
          </label>
          <label className={primitives.field}>
            {t('bootstrapOrgEmail')}
            <input
              type="email"
              name="email"
              autoComplete="email"
              value={formState.email}
              onChange={handleInputChange}
              placeholder={t('bootstrapOrgEmailPlaceholder')}
            />
          </label>
          <label className={primitives.field}>
            {t('bootstrapOrgPhone')}
            <input
              type="tel"
              name="phone"
              autoComplete="tel"
              value={formState.phone}
              onChange={handleInputChange}
              placeholder={t('bootstrapOrgPhonePlaceholder')}
              maxLength={48}
            />
          </label>
          <label className={primitives.field}>
            {t('bootstrapOrgWebsite')}
            <input
              type="url"
              name="website"
              autoComplete="url"
              value={formState.website}
              onChange={handleInputChange}
              placeholder={t('bootstrapOrgWebsitePlaceholder')}
              maxLength={300}
            />
          </label>
          <label className={`${primitives.field} ${styles.spanFull}`}>
            {t('bootstrapOrgAddress')}
            <textarea
              name="physical_address"
              autoComplete="street-address"
              value={formState.physical_address}
              onChange={handleInputChange}
              placeholder={t('bootstrapOrgAddressPlaceholder')}
              rows={2}
              maxLength={300}
            />
          </label>

          <div className={styles.actionsRow}>
            <button className={primitives.primaryButton} type="submit" disabled={isSubmitting}>
              {isSubmitting ? t('bootstrapCreating') : t('bootstrapCreate')}
            </button>
            <button className={primitives.ghostButton} type="button" onClick={onExit}>
              {t('bootstrapBackToLogin')}
            </button>
          </div>
        </form>
      ) : (
        <button className={primitives.primaryButton} type="button" onClick={onComplete}>
          {t('bootstrapBackToLogin')}
        </button>
      )}
    </section>
  );
};
